import type { ExpressionNamespace } from '@/features/sliced-form/schemas/expression'

// Dependency-free so the global test setup can import it without pulling (and
// pre-caching, past vi.mock) the expression library's module graph.

/**
 * Module-level guard so multiple panels mounting on the same namespace
 * don't all race to install seeds at the same time (each
 * `useExpressionLibrary` instance has its own `seedingRef`, which only
 * guards a single instance). One set entry per (namespace) per page load.
 */
export const seededNamespaces = new Set<ExpressionNamespace>()

/** Test hook — clears the auto-seed guard so the effect can fire again. */
export function __resetExpressionSeedingForTest(): void {
  seededNamespaces.clear()
}

/** Test hook — marks all namespaces as already seeded so the effect stays dormant. */
export function __suppressExpressionSeedingForTest(): void {
  seededNamespaces.add('realtime')
  seededNamespaces.add('historical')
}
